export default {
  webBoards: [],
  processing: false,
  error: null,
  success: null,
}



